import { App } from '@capacitor/app';

let lastRedirectUri = null;

// Call this once at app startup
export function initDeepLinks() {
  App.addListener('appUrlOpen', ({ url }) => {
    // Example: https://.../plaid-oauth-redirect.html?oauth_state_id=...
    lastRedirectUri = url;
    // Let the rest of the app know we got the URL
    window.dispatchEvent(
      new CustomEvent('PlaidOAuthRedirect', { detail: url })
    );
  });
}

export function getLastRedirectUri() {
  return lastRedirectUri;
}
